export function checkIsIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
